module.exports = __webpack_public_path__ + "static/educative_jupyter-bd43fdb5b2a3587921cddfc7c228241e.mp4";